export function ContentContainer({ children }: { children: React.ReactNode }) {
  return (
    <div className="p-4 bg-sidebar rounded-lg shadow-sm border w-full">
      {children}
    </div>
  );
}
